module.exports = __webpack_public_path__ + "assets/c9bad99ffeba69a18069ef8f1ff44eb2.mp3";